import { getDownloadURL, ref } from 'firebase/storage';
import { FC, useEffect, useState } from 'react';
import { storage } from '../../../firebase';
import { useAuth } from '../../../hooks/useAuth';
import { AttachedFile } from '../../../types/briefing';

type FileDownloadProps = {
  file: AttachedFile;
};

export const FileDownload: FC<FileDownloadProps> = ({
  file,
}: FileDownloadProps) => {
  const [{ auth }] = useAuth();
  const [fileURL, setFileURL] = useState('');
  useEffect(() => {
    getDownloadURL(
      ref(storage, `userUploads/${auth.uid}/${file.id}/${file.adjustedName}`),
    ).then((url) => {
      setFileURL(url);
    });
  }, [auth, file]);

  return (
    <a
      href={fileURL}
      className="font-regular text-blue-200 hover:text-blue-100 hover:underline hover:pointer"
      download={file.adjustedName}
      target="_blank"
      rel="noopener noreferrer"
    >
      {file.adjustedName}
    </a>
  );
};
